/* Canvas Classics - Save for later (theme-native, localStorage, no third-party script) */
(function() {
  'use strict';

  var KEY = 'cc_saved_v1';
  var SIGNUP_KEY = 'cc_saved_email_v1';

  /* Storage helpers. try/catch keeps private browsing and blocked storage from throwing. */
  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function(item) {
        return item && typeof item.handle === 'string' && item.handle !== '';
      });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* Storage unavailable: the feature degrades to a no-op, page still works. */
    }
  }

  function isSaved(handle) {
    return read().some(function(item) { return item.handle === handle; });
  }

  function toggle(handle, variantId) {
    var list = read();
    var exists = list.some(function(item) { return item.handle === handle; });
    if (exists) {
      list = list.filter(function(item) { return item.handle !== handle; });
    } else {
      list.push({ handle: handle, addedAt: new Date().toISOString(), variantId: variantId || null });
    }
    write(list);
    updateHeader();
    return !exists;
  }

  function remove(handle) {
    write(read().filter(function(item) { return item.handle !== handle; }));
    updateHeader();
  }

  /* Header heart: hidden until something is saved, count badge like the cart badge. */
  function updateHeader() {
    var links = document.querySelectorAll('[data-saved-link]');
    var count = read().length;
    links.forEach(function(link) {
      var badge = link.querySelector('[data-saved-count]');
      if (count > 0) {
        link.removeAttribute('hidden');
        if (badge) badge.textContent = count;
      } else {
        link.setAttribute('hidden', '');
      }
    });
  }

  /* Tracking: report saves to Meta and Klaviyo when their scripts are present.
     Both are guarded so the feature works identically with trackers blocked. */
  function trackSave(info) {
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'AddToWishlist', {
          content_ids: [info.handle],
          content_type: 'product',
          content_name: info.title || info.handle,
          value: info.price || 0,
          currency: 'USD'
        });
      }
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'add_to_wishlist', {
          currency: 'USD',
          value: info.price || 0,
          items: [{
            item_id: info.handle,
            item_name: info.title || info.handle,
            price: info.price || 0,
            quantity: 1
          }]
        });
      }
    } catch (e) {}
    try {
      var klaviyo = window.klaviyo || window._learnq;
      if (klaviyo && typeof klaviyo.push === 'function') {
        klaviyo.push(['track', 'Saved for Later', {
          ProductHandle: info.handle,
          ProductName: info.title || info.handle,
          Price: info.price || 0,
          ImageURL: info.image || '',
          URL: window.location.href
        }]);
      }
    } catch (e) {}
  }

  /* Save toggles: card hearts, the labeled buybox button and the gallery heart
     share state. One delegated listener on document covers every toggle, including
     cards appended by infinite scroll or restored after back-navigation, and the
     pressed state of late-inserted toggles is synced by an observer. Clicking any
     toggle updates every toggle for the same product. */
  function initToggleButtons() {
    syncFromStorage(document);

    document.addEventListener('click', function(event) {
      var btn = event.target.closest ? event.target.closest('[data-save-toggle]') : null;
      if (!btn) return;
      /* Grid hearts live inside the card link; keep the tap from navigating. */
      event.preventDefault();
      event.stopPropagation();
      var handle = btn.dataset.productHandle;
      if (!handle) return;
      /* On a product page, remember the size and frame currently picked in the
         configurator so the wishlist offers that exact variant. theme.js keeps
         the buybox form's id input in sync with the selection. Cards (inside a
         link) belong to other products, so they never take that variant. */
      var variantInput = btn.closest('a') ? null : document.querySelector('[data-buybox] [name="id"]');
      var saved = toggle(handle, variantInput ? variantInput.value : null);
      syncAllButtons(handle, saved);
      if (saved) {
        trackSave({
          handle: handle,
          title: btn.dataset.productTitle,
          price: parseFloat(btn.dataset.productPrice) || 0,
          image: btn.dataset.productImage || ''
        });
      }
    });

    /* Cards inserted later start unpressed in the markup; sync them to storage. */
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function(records) {
        records.forEach(function(rec) {
          rec.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) syncFromStorage(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    /* Back-forward cache restores a page with stale pressed states. */
    window.addEventListener('pageshow', function(event) {
      if (event.persisted) syncFromStorage(document);
    });
  }

  /* Sets every toggle at or under root to match storage. */
  function syncFromStorage(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-save-toggle]'));
    if (root.matches && root.matches('[data-save-toggle]')) buttons.push(root);
    if (buttons.length === 0) return;
    var handles = read().map(function(item) { return item.handle; });
    buttons.forEach(function(btn) {
      var handle = btn.dataset.productHandle;
      if (!handle) return;
      var on = handles.indexOf(handle) !== -1;
      if ((btn.getAttribute('aria-pressed') === 'true') !== on) syncButton(btn, on);
    });
  }

  function syncAllButtons(handle, saved) {
    document.querySelectorAll('[data-save-toggle]').forEach(function(btn) {
      if (btn.dataset.productHandle === handle) syncButton(btn, saved);
    });
  }

  function syncButton(btn, saved) {
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = btn.querySelector('[data-save-label]');
    if (label) label.textContent = saved ? 'Saved' : 'Save for later';
  }

  function formatMoney(cents) {
    var amount = cents / 100;
    var formatted = amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2);
    return '$' + formatted;
  }

  /* Variant picking, shared by the drawer and the saved page. The product JSON
     endpoint may deliver options as strings or objects, so read defensively. */
  function prettyOption(value) {
    return String(value).replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
  }

  function optionNames(product) {
    return (product.options || []).map(function(opt, i) {
      if (typeof opt === 'string') return opt;
      return (opt && opt.name) || 'Option ' + (i + 1);
    });
  }

  function variantOptionValue(variant, index) {
    var byNumber = variant['option' + (index + 1)];
    if (byNumber != null) return String(byNumber);
    if (variant.options && variant.options[index] != null) return String(variant.options[index]);
    return null;
  }

  function defaultVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  /* Builds size/frame selects into container and reports the resolved variant
     through onChange, first with the default and then on every change.
     preferredId (the variant chosen when the piece was saved) wins if it
     still exists on the product. */
  // Frame stock (Theme settings > Frame stock, set in layout/theme.liquid): a sold-out finish
  // resolves to no variant, so Move to cart and Add selected cannot take it. Tokens are
  // "<style>:all" and "<style>:<finish key>" (keys handleized with underscores).
  var frameOut = String(window.CC_FRAME_SOLD_OUT || '').split(',')
    .map(function(s) { return s.trim(); }).filter(Boolean);
  function keyOf(name) {
    return String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  }
  function isFrameSoldOut(v) {
    if (!v || !frameOut.length) return false;
    var style = keyOf(v.option3 || 'Classic').replace(/_/g, '-');
    return frameOut.indexOf(style + ':all') !== -1 || frameOut.indexOf(style + ':' + keyOf(v.option2)) !== -1;
  }

  /* onChange(variant, full): variant is the purchasable variant, or null when the
     selection cannot be bought; full is the resolved variant even when it is sold
     out, so the caller can still show its price. */
  function buildVariantPicker(product, container, onChange, preferredId) {
    var report = onChange;
    var soldNote = null;
    var changeNote = null;
    onChange = function(v) {
      var frameOut = isFrameSoldOut(v);
      var blocked = frameOut || (!!v && v.available === false);
      if (blocked && !soldNote) {
        soldNote = document.createElement('span');
        soldNote.className = 'saved-opt-soldout';
        soldNote.setAttribute('role', 'status');
        container.appendChild(soldNote);
      }
      if (soldNote) {
        soldNote.textContent = frameOut ? 'This finish is sold out' : 'This size and frame is sold out';
        soldNote.hidden = !blocked;
      }
      report(blocked ? null : v, v);
    };
    var variants = product.variants || [];
    var names = optionNames(product);
    var start = null;
    if (preferredId != null) {
      for (var p = 0; p < variants.length; p++) {
        if (String(variants[p].id) === String(preferredId)) { start = variants[p]; break; }
      }
    }
    start = start || defaultVariant(product);
    if (!start) return;

    var singleDefault = variants.length === 1 &&
      variantOptionValue(variants[0], 0) === 'Default Title';
    if (singleDefault || names.length === 0) {
      onChange(start);
      return;
    }

    /* One select per option. Later options (Style) rank above earlier ones
       (Finish, then Size): each select lists only values that exist together with
       the selections ranked above it, so every reachable selection is a real
       variant. Changing a select re-checks the ones ranked below it and swaps in
       a valid value, announced in a note, when the old one no longer exists. */
    var opts = [];
    names.forEach(function(name, i) {
      if (!variants.some(function(v) { return variantOptionValue(v, i) != null; })) return;
      var wrap = document.createElement('label');
      wrap.className = 'saved-opt';
      var nameEl = document.createElement('span');
      nameEl.className = 'saved-opt-name';
      nameEl.textContent = name;
      wrap.appendChild(nameEl);
      var sel = document.createElement('select');
      sel.className = 'saved-opt-select';
      wrap.appendChild(sel);
      container.appendChild(wrap);
      opts.push({ index: i, name: name, sel: sel, value: variantOptionValue(start, i) });
    });

    function optVal(v, q) { return variantOptionValue(v, opts[q].index); }

    /* Variants that agree with every option ranked above position p. */
    function above(p) {
      return variants.filter(function(v) {
        for (var q = p + 1; q < opts.length; q++) {
          if (optVal(v, q) !== opts[q].value) return false;
        }
        return true;
      });
    }
    function valuesAt(p) {
      var out = [];
      above(p).forEach(function(v) {
        var val = optVal(v, p);
        if (val != null && out.indexOf(val) === -1) out.push(val);
      });
      return out;
    }
    /* True when every variant that choosing val would land on is sold out. */
    function soldOutAt(p, val) {
      var pool = above(p).filter(function(v) { return optVal(v, p) === val; });
      var exact = pool.filter(function(v) {
        for (var q = 0; q < p; q++) {
          if (optVal(v, q) !== opts[q].value) return false;
        }
        return true;
      });
      if (exact.length) pool = exact;
      return pool.length > 0 && pool.every(function(v) { return v.available === false; });
    }
    function fill(p) {
      var o = opts[p];
      o.sel.innerHTML = '';
      valuesAt(p).forEach(function(val) {
        var opt = document.createElement('option');
        opt.value = val;
        opt.textContent = prettyOption(val) + (soldOutAt(p, val) ? ' (Sold out)' : '');
        o.sel.appendChild(opt);
      });
      o.sel.value = o.value;
    }
    function current() {
      for (var i = 0; i < variants.length; i++) {
        if (above(-1).indexOf(variants[i]) !== -1) return variants[i];
      }
      return null;
    }
    /* Re-validate every option ranked below position k, highest rank first.
       Keeps the current value when it still exists, else the first value with
       stock, else the first value. Returns a note per option that moved. */
    function settle(k) {
      var notes = [];
      for (var p = Math.min(k, opts.length) - 1; p >= 0; p--) {
        var list = valuesAt(p);
        if (list.indexOf(opts[p].value) !== -1) continue;
        var old = opts[p].value;
        var pick = list[0];
        var pool = above(p);
        for (var j = 0; j < list.length; j++) {
          var inStock = pool.some(function(v) { return optVal(v, p) === list[j] && v.available !== false; });
          if (inStock) { pick = list[j]; break; }
        }
        opts[p].value = pick;
        if (old != null && k < opts.length) {
          notes.push(opts[p].name + ' changed to ' + prettyOption(pick) + ' (' +
            prettyOption(old) + ' is not offered with ' + prettyOption(opts[k].value) + ').');
        }
      }
      return notes;
    }
    function setNote(notes) {
      if (!changeNote && notes.length) {
        changeNote = document.createElement('span');
        changeNote.className = 'saved-opt-soldout';
        changeNote.setAttribute('role', 'status');
        container.appendChild(changeNote);
      }
      if (changeNote) {
        changeNote.textContent = notes.join(' ');
        changeNote.hidden = notes.length === 0;
      }
    }

    settle(opts.length);
    opts.forEach(function(o, p) { fill(p); });

    opts.forEach(function(o, k) {
      o.sel.addEventListener('change', function() {
        if (valuesAt(k).indexOf(o.sel.value) === -1) return;
        o.value = o.sel.value;
        var notes = settle(k);
        opts.forEach(function(other, p) { if (p !== k) fill(p); });
        setNote(notes);
        onChange(current());
      });
    });
    onChange(current() || start);
  }

  function refreshCartBadge() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function() {});
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  /* Saved drawer: slides in from the right when the header heart is tapped.
     The /pages/saved page stays as the full view, linked from the footer. */
  function initDrawer() {
    var drawer = document.querySelector('[data-saved-drawer]');
    if (!drawer) return;
    var backdrop = document.querySelector('[data-saved-drawer-backdrop]');
    var list = drawer.querySelector('[data-saved-drawer-list]');
    var emptyEl = drawer.querySelector('[data-saved-drawer-empty]');

    function open() {
      renderRows();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.inert = false;
      if (backdrop) backdrop.classList.add('is-open');
      document.body.classList.add('saved-drawer-open');
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.classList.remove('saved-drawer-open');
    }

    document.addEventListener('click', function(event) {
      var link = event.target.closest ? event.target.closest('[data-saved-link]') : null;
      if (link) {
        event.preventDefault();
        open();
      }
    });
    if (backdrop) backdrop.addEventListener('click', close);
    var closeBtn = drawer.querySelector('[data-saved-drawer-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    function renderRows() {
      var items = read();
      list.innerHTML = '';
      if (items.length === 0) {
        emptyEl.removeAttribute('hidden');
        return;
      }
      emptyEl.setAttribute('hidden', '');
      items.forEach(function(item) { renderRow(item); });
    }

    function renderRow(item) {
      var row = document.createElement('div');
      row.className = 'saved-row';
      row.innerHTML = '<div class="saved-row-img saved-card-loading"></div><div class="saved-row-main"></div>';
      list.appendChild(row);

      fetch('/products/' + encodeURIComponent(item.handle) + '.js')
        .then(function(res) {
          if (res.status === 404) {
            remove(item.handle);
            row.remove();
            if (read().length === 0) renderRows();
            return null;
          }
          if (!res.ok) throw new Error('http ' + res.status);
          return res.json();
        })
        .then(function(product) {
          if (!product) return;
          var imgSrc = product.featured_image || '';
          if (imgSrc) imgSrc += (imgSrc.indexOf('?') === -1 ? '?' : '&') + 'width=240';
          row.innerHTML =
            '<a class="saved-row-img" href="' + escapeHtml(product.url) + '">' +
              (imgSrc ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="saved-row-main">' +
              '<a class="saved-row-title" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
              '<div class="saved-row-opts"></div>' +
              '<div class="saved-row-bottom">' +
                '<span class="saved-row-price"></span>' +
                '<button type="button" class="saved-row-add">Move to cart</button>' +
                '<button type="button" class="saved-row-remove">Remove</button>' +
              '</div>' +
            '</div>';

          var priceEl = row.querySelector('.saved-row-price');
          var addBtn = row.querySelector('.saved-row-add');
          var currentVariant = null;
          buildVariantPicker(product, row.querySelector('.saved-row-opts'), function(variant, full) {
            currentVariant = variant;
            priceEl.textContent = full ? formatMoney(full.price) : '';
            addBtn.disabled = !variant;
          }, item.variantId);

          addBtn.addEventListener('click', function() {
            if (!currentVariant) return;
            addBtn.disabled = true;
            addBtn.textContent = 'Adding...';
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: currentVariant.id, quantity: 1 }] })
            })
              .then(function(res) {
                if (!res.ok) throw new Error('http ' + res.status);
                remove(item.handle);
                row.remove();
                refreshCartBadge();
                if (read().length === 0) renderRows();
                if (window.CCCart) {
                  window.CCCart.refresh().then(function() {
                    close();
                    window.CCCart.open();
                  });
                } else {
                  window.location.href = '/cart';
                }
              })
              .catch(function() {
                addBtn.disabled = false;
                addBtn.textContent = 'Move to cart';
              });
          });

          row.querySelector('.saved-row-remove').addEventListener('click', function() {
            remove(item.handle);
            row.remove();
            if (read().length === 0) renderRows();
          });
        })
        .catch(function() {
          row.innerHTML =
            '<div></div><div class="saved-row-main">' +
              '<div class="saved-row-title">' + escapeHtml(item.handle.replace(/-/g, ' ')) + '</div>' +
              '<div class="saved-drawer-empty-copy">Could not load right now. It is still saved.</div>' +
            '</div>';
        });
    }
  }

  /* Saved page: render each saved handle from the public product JSON endpoint. */
  function initSavedPage() {
    var page = document.querySelector('[data-saved-page]');
    if (!page) return;

    var grid = page.querySelector('[data-saved-grid]');
    var empty = page.querySelector('[data-saved-empty]');
    var toolbar = page.querySelector('[data-saved-toolbar]');
    var toolbarCount = page.querySelector('[data-saved-selected-count]');
    var addSelectedBtn = page.querySelector('[data-saved-add-selected]');

    function selectedCards() {
      return Array.prototype.filter.call(
        grid.querySelectorAll('.saved-card'),
        function(card) {
          var box = card.querySelector('[data-saved-select]');
          return box && box.checked && card.dataset.variantId;
        }
      );
    }

    function updateToolbar() {
      if (!toolbar) return;
      var count = selectedCards().length;
      if (addSelectedBtn) addSelectedBtn.disabled = count === 0;
      toolbarCount.textContent = count > 0
        ? count + ' selected'
        : 'Check the box on each piece you want, then add them all to your cart at once.';
    }

    if (addSelectedBtn) {
      addSelectedBtn.addEventListener('click', function() {
        var cards = selectedCards();
        var items = cards.map(function(card) {
          return { id: parseInt(card.dataset.variantId, 10), quantity: 1 };
        });
        if (items.length === 0) return;
        addSelectedBtn.disabled = true;
        addSelectedBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function(res) {
            if (!res.ok) throw new Error('http ' + res.status);
            /* Moved to cart means no longer waiting here: unsave them so the
               header count and this page stay honest. */
            cards.forEach(function(card) {
              remove(card.dataset.savedHandle);
            });
            window.location.href = '/cart';
          })
          .catch(function() {
            addSelectedBtn.disabled = false;
            addSelectedBtn.textContent = 'Add selected to cart';
            toolbarCount.textContent = 'Something went wrong. Please try again.';
          });
      });
    }

    function render() {
      var list = read();
      grid.innerHTML = '';
      updateToolbar();
      if (list.length === 0) {
        empty.removeAttribute('hidden');
        grid.setAttribute('hidden', '');
        if (toolbar) toolbar.setAttribute('hidden', '');
        return;
      }
      empty.setAttribute('hidden', '');
      grid.removeAttribute('hidden');
      if (toolbar) toolbar.removeAttribute('hidden');

      list.forEach(function(item) {
        var card = document.createElement('div');
        card.className = 'saved-card';
        card.dataset.savedHandle = item.handle;
        card.innerHTML = '<div class="saved-card-media saved-card-loading"></div>';
        grid.appendChild(card);

        fetch('/products/' + encodeURIComponent(item.handle) + '.js')
          .then(function(res) {
            if (res.status === 404) {
              /* Product no longer exists: prune it so the count stays honest. */
              remove(item.handle);
              card.remove();
              if (read().length === 0) render();
              return null;
            }
            if (!res.ok) throw new Error('http ' + res.status);
            return res.json();
          })
          .then(function(product) {
            if (!product) return;
            var imgSrc = product.featured_image || '';
            if (imgSrc) {
              imgSrc += (imgSrc.indexOf('?') === -1 ? '?' : '&') + 'width=600';
            }
            var img = imgSrc
              ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
              : '';
            card.innerHTML =
              '<label class="saved-select" aria-label="Select ' + escapeHtml(product.title) + '">' +
                '<input type="checkbox" data-saved-select>' +
                '<span class="saved-select-box">✓</span>' +
              '</label>' +
              '<a class="saved-card-media" href="' + escapeHtml(product.url) + '">' + img + '</a>' +
              '<div class="saved-card-info">' +
                '<a class="saved-card-title" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
                '<div class="saved-card-opts saved-row-opts"></div>' +
                '<div class="saved-card-price"></div>' +
                '<div class="saved-card-actions">' +
                  '<a class="btn btn-primary saved-card-view" href="' + escapeHtml(product.url) + '">View piece</a>' +
                  '<button type="button" class="saved-card-remove" data-saved-remove>Remove</button>' +
                '</div>' +
              '</div>';
            var cardPrice = card.querySelector('.saved-card-price');
            buildVariantPicker(product, card.querySelector('.saved-card-opts'), function(variant, full) {
              if (variant) card.dataset.variantId = variant.id;
              else delete card.dataset.variantId;
              cardPrice.textContent = full ? formatMoney(full.price) : '';
              updateToolbar();
            }, item.variantId);
            var removeBtn = card.querySelector('[data-saved-remove]');
            removeBtn.addEventListener('click', function() {
              remove(item.handle);
              card.remove();
              updateToolbar();
              if (read().length === 0) render();
            });
            var selectBox = card.querySelector('[data-saved-select]');
            selectBox.addEventListener('change', function() {
              card.classList.toggle('is-selected', selectBox.checked);
              updateToolbar();
            });
          })
          .catch(function() {
            /* Network hiccup: keep the item saved, show a plain retry note. */
            card.innerHTML =
              '<div class="saved-card-info">' +
                '<div class="saved-card-title">' + escapeHtml(item.handle.replace(/-/g, ' ')) + '</div>' +
                '<div class="saved-card-price">Could not load right now. It is still saved.</div>' +
              '</div>';
          });
      });
    }

    render();
  }

  /* Cross-device restore: /pages/saved?restore=handle-a,handle-b merges those
     handles into this device's saved list. The link comes from the wishlist
     signup email, so a shopper can reopen their favorites on a new device
     without an account. The param is stripped after the merge so reloads and
     shared URLs stay clean. */
  function applyRestoreParam() {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('restore');
    if (!raw) return;
    var list = read();
    raw.split(',').forEach(function(handle) {
      handle = handle.trim();
      if (!handle || !/^[a-z0-9_-]+$/i.test(handle)) return;
      if (list.some(function(item) { return item.handle === handle; })) return;
      list.push({ handle: handle, addedAt: new Date().toISOString(), variantId: null });
    });
    write(list);
    params.delete('restore');
    var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    history.replaceState(null, '', clean);
  }

  function restoreLink() {
    var handles = read().map(function(item) { return item.handle; }).slice(0, 40);
    return window.location.origin + '/pages/saved?restore=' + handles.join(',');
  }

  function signupState() {
    try {
      return JSON.parse(localStorage.getItem(SIGNUP_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  /* Wishlist signup: subscribes via Klaviyo's client API (list "Wishlist
     Signup"), stores the saved handles and a restore link on the profile so
     the welcome flow can email them, then identifies the browser so future
     saves track as this person. Forms stay hidden when nothing is saved or
     after a signup already happened on this device. */
  function initSignup() {
    var boxes = document.querySelectorAll('[data-saved-signup]');
    if (boxes.length === 0) return;

    function syncVisibility() {
      var show = read().length > 0 && !signupState();
      boxes.forEach(function(box) {
        /* A box showing the "check your inbox" confirmation stays visible even
           though the signup flag is now set. */
        var done = box.querySelector('[data-saved-signup-done]');
        if (done && !done.hasAttribute('hidden')) return;
        if (show) box.removeAttribute('hidden');
        else box.setAttribute('hidden', '');
      });
    }
    syncVisibility();
    /* Saves and removals happen after load; re-check whenever storage-backed
       UI refreshes. Cheap enough to run on every click. */
    document.addEventListener('click', function() {
      setTimeout(syncVisibility, 0);
    });

    boxes.forEach(function(box) {
      var form = box.querySelector('[data-saved-signup-form]');
      var errorEl = box.querySelector('[data-saved-signup-error]');
      var doneEl = box.querySelector('[data-saved-signup-done]');
      if (!form) return;
      form.addEventListener('submit', function(event) {
        event.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var email = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          errorEl.textContent = 'Please enter a valid email address.';
          errorEl.removeAttribute('hidden');
          return;
        }
        errorEl.setAttribute('hidden', '');
        var btn = form.querySelector('button');
        btn.disabled = true;
        btn.textContent = 'Sending...';

        var handles = read().map(function(item) { return item.handle; });
        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Wishlist Signup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: {
                      SavedItems: handles,
                      SavedItemCount: handles.length,
                      SavedRestoreLink: restoreLink()
                    }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: box.dataset.listId } }
            }
          }
        };

        var subscribeUrl = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(box.dataset.companyId);
        fetch(subscribeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2025-04-15' },
          body: JSON.stringify(payload)
        })
          .then(function(res) {
            if (!res.ok) throw new Error('http ' + res.status);
            /* Also join the main newsletter list (the form promises new-arrival
               emails). The client API takes one list per call; fire-and-forget
               so a failure here never blocks the restore-link signup. */
            if (box.dataset.newsletterListId) {
              var newsletterPayload = JSON.parse(JSON.stringify(payload));
              newsletterPayload.data.relationships.list.data.id = box.dataset.newsletterListId;
              fetch(subscribeUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', revision: '2025-04-15' },
                body: JSON.stringify(newsletterPayload)
              }).catch(function() {});
            }
            try {
              localStorage.setItem(SIGNUP_KEY, JSON.stringify({ email: email, at: new Date().toISOString() }));
            } catch (e) {}
            /* Cookie this browser as the person so every later save tracks
               as an identified Klaviyo event, not an anonymous one. */
            try {
              var klaviyo = window.klaviyo || window._learnq;
              if (klaviyo && typeof klaviyo.push === 'function') {
                klaviyo.push(['identify', { email: email }]);
              }
            } catch (e) {}
            boxes.forEach(function(other) {
              var f = other.querySelector('[data-saved-signup-form]');
              var c = other.querySelector('.saved-signup-copy');
              var d = other.querySelector('[data-saved-signup-done]');
              if (f) f.setAttribute('hidden', '');
              if (c) c.setAttribute('hidden', '');
              if (d) d.removeAttribute('hidden');
            });
          })
          .catch(function() {
            btn.disabled = false;
            btn.textContent = 'Email my favorites';
            errorEl.textContent = 'Something went wrong. Please try again.';
            errorEl.removeAttribute('hidden');
          });
      });
    });
  }

  function init() {
    applyRestoreParam();
    updateHeader();
    initToggleButtons();
    initDrawer();
    initSavedPage();
    initSignup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
